"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./CustomFieldDropdown.css");
var CFD = require('player-search-module').CustomFieldDropdown;
var CustomFieldDropdown = (function (_super) {
    __extends(CustomFieldDropdown, _super);
    function CustomFieldDropdown(props) {
        return _super.call(this, props) || this;
    }
    CustomFieldDropdown.prototype.render = function () {
        var _a = this.props, tag = _a.tag, items = _a.items, isMultiselect = _a.isMultiselect, placeholderText = _a.placeholderText, buttonTextSuffix = _a.buttonTextSuffix, onChange = _a.onChange, isVisible = _a.isVisible;
        return (isVisible ? React.createElement("div", { className: "p-customfielddropdown" },
            React.createElement(CFD, { tag: tag, items: items, isMultiselect: isMultiselect, placeholderText: placeholderText, buttonTextSuffix: buttonTextSuffix, onChange: onChange })) : null);
    };
    return CustomFieldDropdown;
}(React.Component));
CustomFieldDropdown.defaultProps = {
    tag: null,
    items: [],
    isMultiselect: false,
    isVisible: false,
    placeholderText: '',
    buttonTextSuffix: '',
};
exports.CustomFieldDropdown = CustomFieldDropdown;

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["CustomFieldDropdown"] = [];


//////////////////
// WEBPACK FOOTER
// C:/TeamCity/buildAgent/work/f257358f111b2299/src/.tmp/CustomFieldDropdown/CustomFieldDropdown.js
// module id = 566
// module chunks = 0